import React, { useState, useEffect, useRef } from 'react';


const Offices = () => {
    const [openList, setOpenList] = useState(null);
    const [activeButton, setActiveButton] = useState('all');
    const [buttonWidths, setButtonWidths] = useState({});
    const buttonRefs = useRef({});
    const [selectedCountry, setSelectedCountry] = useState('');
    const [selectedCity, setSelectedCity] = useState('');
    const [selectedType, setSelectedType] = useState('all');

    // const countryCityMap = {
    //     // 'Китай': ['Шо-Там-Нахуй', 'Пекин'],
    //     // 'США': ['Нью-Йорк'],
    //     // 'Германия': ['Берлин'],
    // };
    const officesData = [
        { id: 1, type: 'warehouse', country: 'Китай', city: 'Гуанчжоу', img: '/img/offices/s2.jpg', hours: 'Пн-Пт (9:00-18:00), Сб-Вс (10:00-15:00)' },
        // { id: 2, type: 'office', country: 'Китай', city: 'Шо-Там-Нахуй', img: '/img/offices/s2.jpg', hours: 'Пн-Пт (9:00-18:00), Сб-Вс (10:00-15:00)' },
        { id: 1, type: 'warehouse', country: 'Россия', city: 'Москва', img: '/img/offices/s1.jpg', hours: 'Пн-Пт (9:00-18:00), Сб-Вс (10:00-15:00)' },
        { id: 1, type: 'office', country: 'Россия', city: 'Москва', img: '/img/offices/s2.jpg', hours: 'Пн-Пт (9:00 до 19:00)' },
        // { id: 5, type: 'warehouse', country: 'Германия', city: 'Берлин', img: '/img/offices/s1.jpg', hours: 'Пн-Пт (9:00-18:00), Сб-Вс (10:00-15:00)' },
    ];

    let countryCityMap = {};

    officesData.forEach((x, _index) => {
        if (!countryCityMap[x.country]) countryCityMap[x.country] = [];
        if (!countryCityMap[x.country].includes(x.city)) countryCityMap[x.country].push(x.city);
    });

    const countries = Object.keys(countryCityMap);
    const allCities = Object.values(countryCityMap).flat();


    const toggleList = (listName) => {
        setOpenList(openList === listName ? null : listName);
    };

    const handleButtonClick = (button) => {
        setActiveButton(button);
        setSelectedType(button === 'all' ? 'all' : button === 'warehouses' ? 'warehouse' : 'office');
    };

    const getGap = () => {
        return window.innerWidth < 640 ? 24 : 32; 
    };

    useEffect(() => {
        const updateButtonWidths = () => {
            const widths = {};
            Object.keys(buttonRefs.current).forEach((key) => {
                if (buttonRefs.current[key]) {
                    widths[key] = buttonRefs.current[key].getBoundingClientRect().width;
                }
            });
            setButtonWidths(widths);
        };

        updateButtonWidths();
        window.addEventListener('resize', updateButtonWidths);
        
        return () => {
            window.removeEventListener('resize', updateButtonWidths);
        };
    }, [activeButton]); 

    const filteredOffices = officesData.filter(office => {
        const matchesCountry = selectedCountry ? office.country === selectedCountry : true;
        const matchesCity = selectedCity ? office.city === selectedCity : true;
        const matchesType = selectedType !== 'all' ? office.type === selectedType : true;
        return matchesCountry && matchesCity && matchesType;
    });

    const sliderRef = useRef(null);
    const [isDragging, setIsDragging] = useState(false);
    const [startX, setStartX] = useState(0);
    const [scrollLeft, setScrollLeft] = useState(0);

    const handleMouseDown = (e) => {
        setIsDragging(true);
        setStartX(e.pageX - sliderRef.current.offsetLeft);
        setScrollLeft(sliderRef.current.scrollLeft);
    };

    const handleMouseLeave = () => {
        setIsDragging(false);
    };

    const handleMouseUp = () => {
        setIsDragging(false);
    };

    const handleMouseMove = (e) => {
        if (!isDragging) return;
        e.preventDefault();
        const x = e.pageX - sliderRef.current.offsetLeft;
        const walk = (x - startX) * 1; 
        sliderRef.current.scrollLeft = scrollLeft - walk;
    };

    const handleScrollRight = () => {
        if (sliderRef.current) {
            const slides = sliderRef.current.children;
            if (slides.length > 0) {
                const slideWidth = slides[0].getBoundingClientRect().width;
                sliderRef.current.scrollBy({
                    left: slideWidth + 20,
                    behavior: 'smooth'
                });
            }
        }
    };

    const handleScrollLeft = () => {
        if (sliderRef.current) {
            const slides = sliderRef.current.children;
            if (slides.length > 0) {
                const slideWidth = slides[0].getBoundingClientRect().width;
                sliderRef.current.scrollBy({
                    left: -slideWidth - 20,
                    behavior: 'smooth'
                });
            }
        }
    };

    return (
        <div id='offices' className='pt-[120px]'>

        
            <div className="mb-[100px] w-[98%] max-w-[1550px] px-[10px] sm:px[20px] font-medium mx-auto flex justify-center md:flex-row flex-col gap-[20px] lg:h-[610px] md:h-[500px]">

                <div className="bg-[#C3372E] rounded-[24px] lg:h-full h-[500px] lg:w-[30%]  w-[100%] pt-[72px] px-[24px] bg-left bg-no-repeat  bg-cover" style={{ backgroundImage: "url('/img/offices/bg.png')"}}>
                    <div className="max-w-[370px] text-[#fff] lg:text-[32px] sm:text-[28px] text-[24px]">
                        Вы можете прийти в любой из наших офисов:
                    </div>

                    <div className="mt-[31px]">
                        <div 
                            className="openSpisok mb-[8px] cursor-pointer bg-[#A82C24] text-[#fff] py-[12px] px-[16px] rounded-[12px]" 
                            onClick={() => toggleList('country')}>
                            <div className="flex justify-between items-center">
                                <div>
                                    <div className="text-[12px] mb-[8px]">Страна</div>
                                    <div>{selectedCountry || 'Выберете из списка'}</div>
                                </div>
                                <div>
                                    <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                                        <g opacity="0.3">
                                            <path d="M15.5887 8.08867L9.99941 13.6779L4.41016 8.08867L5.58867 6.91016L9.99941 11.3209L14.4102 6.91016L15.5887 8.08867Z" fill="white"/>
                                        </g>
                                    </svg>
                                </div>
                            </div>
                            <div className={`transition-all duration-500 ease-in-out overflow-hidden ${openList === 'country' ? 'max-h-[120px] mt-[20px] block' : 'max-h-0'}`}>
                                <div className="custom-scroll max-h-[120px] flex flex-col gap-[10px]">        
                                    {countries.map(country => (
                                        <div key={country} className="flex items-center gap-[8px] text-[#E77B78] duration-300 hover:text-white group" onClick={() => { setSelectedCountry(country); setSelectedCity(''); toggleList('country'); }}>
                                            {country}
                                        </div>
                                    ))}
                                </div>
                            </div>
                        </div>

                        <div 
                            className="openSpisok mb-[8px] cursor-pointer bg-[#A82C24] text-[#fff] py-[12px] px-[16px] rounded-[12px]" 
                            onClick={() => toggleList('city')}
                        >
                            <div className="flex justify-between items-center">
                                <div>
                                    <div className="text-[12px] mb-[8px]">Город</div>
                                    <div>{selectedCity || 'Выберете из списка'}</div>
                                </div>
                                <div>
                                    <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                                        <g opacity="0.3">
                                            <path d="M15.5887 8.08867L9.99941 13.6779L4.41016 8.08867L5.58867 6.91016L9.99941 11.3209L14.4102 6.91016L15.5887 8.08867Z" fill="white"/>
                                        </g>
                                    </svg>
                                </div>
                            </div>
                            <div className={`transition-all duration-500 ease-in-out overflow-hidden ${openList === 'city' ? 'max-h-[120px] mt-[20px] block' : 'max-h-0'}`}>
                                <div className="custom-scroll max-h-[120px] flex flex-col gap-[10px]">        
                                    {(selectedCountry ? countryCityMap[selectedCountry] : allCities).map(city => (
                                        <div key={city} className="flex items-center gap-[8px] text-[#E77B78] duration-300 hover:text-white group" onClick={() => { 
                                            setSelectedCity(city); 
                                            setSelectedCountry(Object.keys(countryCityMap).find(country => countryCityMap[country].includes(city))); 
                                            toggleList('city'); 
                                        }}>
                                            {city}
                                        </div>
                                    ))}
                                </div>
                            </div>
                        </div>

                    </div>
                </div>

                <div className="h-full md:w-[70%] w-[100%] py-[24px] pl-[24px] bg-[#EFF0F2] rounded-[24px]">
                    <div className='flex items-center justify-between w-full'>
                        <div className="relative xl:w-[700px] flex sm:gap-[32px] gap-[24px] pb-[16px]">
                            <button 
                                ref={(el) => (buttonRefs.current['all'] = el)} 
                                className={`text-[16px] xl:text-[20px] hover:text-[#1F2225] ${activeButton === 'all' ? 'text-[#1F2225]' : 'text-[#626C75]'}`}
                                onClick={() => handleButtonClick('all')}>
                                Все
                            </button>
                            <button 
                                ref={(el) => (buttonRefs.current['warehouses'] = el)} 
                                className={`text-[16px] xl:text-[20px] hover:text-[#1F2225] ${activeButton === 'warehouses' ? 'text-[#1F2225]' : 'text-[#626C75]'}`}
                                onClick={() => handleButtonClick('warehouses')}>
                                Склады
                            </button>
                            <button 
                                ref={(el) => (buttonRefs.current['offices'] = el)} 
                                className={`text-[16px] xl:text-[20px] hover:text-[#1F2225] ${activeButton === 'offices' ? 'text-[#1F2225]' : 'text-[#626C75]'}`}
                                onClick={() => handleButtonClick('offices')}>
                                Офисы
                            </button>

                            <div className="absolute bottom-0 left-0 w-full h-[2px] bg-[#C9CED2]"></div>
                            <div 
                                className={`absolute bottom-0 h-[2px] bg-[#C3372E] transition-all duration-300`}
                                style={{
                                    width: buttonWidths[activeButton] || '0px', 
                                    transform: `translateX(${activeButton === 'all' ? '0' : activeButton === 'warehouses' ? `${buttonWidths['all'] + getGap()}px` : `${buttonWidths['all'] + buttonWidths['warehouses'] + (getGap() * 2)}px`})`, 
                                }}></div>
                        </div>
                        <div className='pr-[20px] flex items-center gap-[40px]'>
                            <button onClick={handleScrollLeft} id='sBtnPrev'>
                                <svg width="15" height="24" viewBox="0 0 15 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                    <path d="M11.8211 0.822266L0.642578 12.0008L11.8211 23.1793L14.1781 20.8223L5.35662 12.0008L14.1781 3.17929L11.8211 0.822266Z" fill="#626C75"/>
                                </svg>
                            </button>

                            <button onClick={handleScrollRight} id='sBtnNext'> 
                                <svg width="15" height="24" viewBox="0 0 15 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                    <path d="M3.17929 0.822266L14.3578 12.0008L3.17929 23.1793L0.822266 20.8223L9.64375 12.0008L0.822266 3.17929L3.17929 0.822266Z" fill="#626C75"/>
                                </svg>
                            </button>
                        </div>
                    </div>

                    <div id='slider'
                        ref={sliderRef}
                        onMouseDown={handleMouseDown}
                        onMouseLeave={handleMouseLeave}
                        onMouseUp={handleMouseUp}
                        onMouseMove={handleMouseMove} className='w-full mt-[32px] flex gap-[20px] overflow-x-auto scroll-hidden'>

                        {filteredOffices.map(office => (
                            <div key={office.id} style={{background: `url(${office.img})`}} className='lg:min-w-[409px] md:min-w-[365px] min-w-[281px] max-w-[282px] lg:h-[490px] md:h-[400px] h-[348px] rounded-[16px] sm:p-[20px] p-[5px] flex flex-col justify-between text-[#fff] text-[14px]'>
                                <div className='bg-[#C3372E] py-[6px] px-[12px] w-fit rounded-[19px]'>
                                    {office.type === 'warehouse' ? 'Склад' : 'Офис'}
                                </div>
                                <div className='flex flex-col gap-[4px]'>
                                    <div className='flex items-center gap-[5px] bg-[#1F2225] py-[6px] px-[12px] w-fit rounded-[19px]'>
                                        <img src='/img/offices/ic1.png' alt="icon" />
                                        {office.country}
                                    </div>
                                    <div className='flex items-center gap-[5px] bg-[#1F2225] py-[6px] px-[12px] w-fit rounded-[19px]'>
                                        <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                                            <path fillRule="evenodd" clipRule="evenodd" d="M8.15101 13.9644C9.02041 13.5397 13.3327 11.2336 13.3327 7.26572C13.3327 4.35754 10.9449 2 7.99935 2C5.05383 2 2.66602 4.35754 2.66602 7.26572C2.66602 11.2336 6.97829 13.5397 7.84769 13.9644C7.94495 14.0119 8.05374 14.0119 8.15101 13.9644ZM7.99935 9.52246C9.26171 9.52246 10.2851 8.51208 10.2851 7.26572C10.2851 6.01936 9.26171 5.00898 7.99935 5.00898C6.73698 5.00898 5.71363 6.01936 5.71363 7.26572C5.71363 8.51208 6.73698 9.52246 7.99935 9.52246Z" fill="#626C75"/>
                                        </svg>
                                        {office.city}
                                    </div>
                                    <div className='flex items-center gap-[5px] bg-[#1F2225] py-[6px] px-[12px] w-fit rounded-[19px]'>
                                        <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                                            <path d="M8.66732 5.66732C8.66732 5.29913 8.36884 5.00065 8.00065 5.00065C7.63246 5.00065 7.33398 5.29913 7.33398 5.66732V7.91732C7.33398 8.33153 7.66977 8.66732 8.08398 8.66732H11.0007C11.3688 8.66732 11.6673 8.36884 11.6673 8.00065C11.6673 7.63246 11.3688 7.33398 11.0007 7.33398H8.66732V5.66732Z" fill="#626C75"/>
                                            <path fillRule="evenodd" clipRule="evenodd" d="M8.00065 14.6673C11.6825 14.6673 14.6673 11.6825 14.6673 8.00065C14.6673 4.31875 11.6825 1.33398 8.00065 1.33398C4.31875 1.33398 1.33398 4.31875 1.33398 8.00065C1.33398 11.6825 4.31875 14.6673 8.00065 14.6673ZM13.334 8.00065C13.334 10.9462 10.9462 13.334 8.00065 13.334C5.05513 13.334 2.66732 10.9462 2.66732 8.00065C2.66732 5.05513 5.05513 2.66732 8.00065 2.66732C10.9462 2.66732 13.334 5.05513 13.334 8.00065Z" fill="#626C75"/>
                                        </svg>
                                        {office.hours}
                                    </div>
                                </div>
                            </div>
                        ))}
                    </div>
                </div>
            </div>
        </div>
    );
};

export default Offices;
